export default __webpack_public_path__ + "static/media/categories.e14f26c3.svg";